export const fileTableConfig = {
  name: { maxWidth: '20%', title: 'File Name', paddingRight: 10 },
  description: { maxWidth: '75%', title: 'Description' },
  removeButton: { maxWidth: '5%', title: 'Action' },
}

export const fileTableTitles = Object.values(fileTableConfig).map(({ title, maxWidth }) => ({
  title,
  maxWidth,
}))
